import { toWholeCents } from './money';

// Pure row building for the Excel export (no window, no XLSX), so the numbers can be tested.

export function excelColType(data, key) {
  if (key === 'margin') return 'pct';
  if (key === 'jobs' || key === 'count') return 'int';
  const sample = data.find(r => typeof r[key] === 'number');
  if (sample) return 'usd';
  return 'text';
}

// Sum in whole cents, convert once at the end, so 0.1 + 0.2 is exactly 0.3.
export function sumInCents(values) {
  const cents = values.reduce((s, v) => s + (typeof v === 'number' && Number.isFinite(v) ? toWholeCents(v) : 0), 0);
  return cents / 100;
}

// Returns { types, dataRows, totalsRow }. Cells stay numbers so Excel can do math on them.
// Money and count columns are summed; percent columns are left blank (a sum of percentages is meaningless).
export function buildExcelRows(data) {
  const keys = Object.keys(data[0]);
  const types = keys.map(k => excelColType(data, k));
  const dataRows = data.map(row =>
    keys.map((k, i) => {
      const v = row[k];
      if (typeof v !== 'number') return v ?? '';
      if (types[i] === 'pct') return v / 100; // Excel stores pct as decimal
      return v;
    })
  );
  const totalsRow = keys.map((k, i) => {
    if (types[i] === 'usd' || types[i] === 'int') return sumInCents(data.map(r => r[k]));
    if (i === 0) return 'Total';
    return '';
  });
  return { keys, types, dataRows, totalsRow };
}
